import { createSelector } from 'reselect';

const selectComments = (state) => state.comment;

const makeSelectComments = () =>
  createSelector(selectComments, (state) => state.comments);
const makeSelectLoading = () =>
  createSelector(selectComments, (state) => state.loading);
const makeSelectLoadingAppend = () =>
  createSelector(selectComments, (state) => state.loadingAppendComment);

const makeSelectLoadingReply = () =>
  createSelector(selectComments, (state) => state.loadingReply);
const makeSelectLoadingReplyAppend = () =>
  createSelector(selectComments, (state) => state.loadingAppendReplyComment);

const makeSelectLoadingSubmit = () =>
  createSelector(selectComments, (state) => state.loadingSubmit);
const makeSelectCountComment = () =>
  createSelector(selectComments, (state) => state.countComment);

export {
  selectComments,
  makeSelectComments,
  makeSelectLoading,
  makeSelectLoadingReply,
  makeSelectLoadingAppend,
  makeSelectLoadingReplyAppend,
  makeSelectLoadingSubmit,
  makeSelectCountComment,
};
